import React from "react";
import { Col, Input, Label } from "reactstrap";
import {
  CATALOGUE_SHARE_COUNTRIES,
  DEFAULT_SHARE_COUNTRY_ISO,
} from "./catalogueShareCountries";

type ShareCountryPhoneFieldsProps = {
  countryIso: string;
  phone: string;
  onCountryChange: (iso: string) => void;
  onPhoneChange: (phone: string) => void;
  countryId?: string;
  phoneId?: string;
  phonePlaceholder?: string;
  /** Open links need no number; it is only for sending the link. */
  phoneOptional?: boolean;
  /** Label for the number field. Default "Mobile". */
  phoneLabel?: string;
  mdCountry?: number;
  mdPhone?: number;
};

const ShareCountryPhoneFields: React.FC<ShareCountryPhoneFieldsProps> = ({
  countryIso,
  phone,
  onCountryChange,
  onPhoneChange,
  countryId = "share-country",
  phoneId = "share-phone",
  phonePlaceholder = "Local mobile (07911…, 050…)",
  phoneOptional,
  phoneLabel = "Mobile",
  mdCountry = 4,
  mdPhone = 8,
}) => {
  const iso = countryIso || DEFAULT_SHARE_COUNTRY_ISO;
  return (
    <>
      <Col md={mdCountry} sm={6}>
        <Label className="fw-bold" for={countryId}>
          Country
        </Label>
        <Input
          id={countryId}
          type="select"
          value={iso}
          onChange={(e) => onCountryChange(e.target.value)}
        >
          {CATALOGUE_SHARE_COUNTRIES.map((country) => (
            <option key={country.iso} value={country.iso}>
              {country.label}
            </option>
          ))}
        </Input>
      </Col>
      <Col md={mdPhone} sm={6}>
        <Label className="fw-bold" for={phoneId}>
          {phoneOptional ? `${phoneLabel} (optional)` : `${phoneLabel} *`}
        </Label>
        <Input
          id={phoneId}
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          placeholder={iso === "IN" ? "10-digit Indian mobile" : phonePlaceholder}
        />
      </Col>
    </>
  );
};

export default ShareCountryPhoneFields;
